import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import DashboardItem from './DashboardItem';
import api from '../../api/api';

export default function Dashboard() {

  const [dashboard, setDashboard] = useState([]);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const response = await api.get('/api/Dashboard');
      setDashboard(response.data);
    } catch (error) {
      console.error('Error fetching Dashboard', error);
    } 
  };

  return (      
    <Grid container spacing={3}>
      {/* Car */}
      <DashboardItem image="/images/taxi.svg" title="Car Requirement" request={dashboard.carRequests} action_lable="View Requests" path={"car-request"} action/>
      {/* Courier */}
      <DashboardItem image="/images/delivery.svg" title="Courier Requirement" request={dashboard.courierRequests} action_lable="View Requests" path={"courier-request"} action/>
      {/* Travel tickets booking */}
      <DashboardItem image="/images/tour.svg" title="Travel Tickets Booking" request={dashboard.travelTicketRequests} action_lable="View Requests" path={"travel-tickets-request"} action/>
      {/* hotel booking */}
      <DashboardItem image="/images/hotel.svg" title="Hotel Booking" request={dashboard.hotelBookingRequests} action_lable="View Requests" path={"hotel-request"} action/>
      {/* expense claim */}
      <DashboardItem image="/images/expense.svg" title="Expense Claim" request={dashboard.expenseRequests} action_lable="View Requests" path={"expense-request"} action/>
      {/* Uniform requirement */}
      <DashboardItem image="/images/uniform.svg" title="Uniform Requirement" request={dashboard.uniformRequests} action_lable="View Requests" path={"uniform-request"} action/>
      {/* Shoes requirement */}
      <DashboardItem image="/images/shoes.svg" title="Shoes Requirement" request={dashboard.shoesRequests} action_lable="View Requests" path={"shoes-request"} action/>
      {/* Recent Orders */}
      {/* <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <Orders />
        </Paper>
      </Grid> */}
    </Grid>
  );
}
